import { render, staticRenderFns } from "./SLink.vue?vue&type=template&id=4b9ede67&scoped=true"
import script from "./SLink.vue?vue&type=script&lang=js"
export * from "./SLink.vue?vue&type=script&lang=js"
import style0 from "./SLink.vue?vue&type=style&index=0&id=4b9ede67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ede67",
  null
  
)

export default component.exports